import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { UserListEmailAddressCell } from './user-list-email-address.cell';
import { UserListEmailAddressHeader } from './user-list-email-address.header';

export const UserListEmailAddressColumn: IdentifiedColumnDef<
  GatewayUserModel,
  GatewayUserModel['emailAddress']
> = {
  enableSorting: true,
  header: UserListEmailAddressHeader,
  cell: UserListEmailAddressCell,
};
